import {usePromotion} from '@/context/Promotion/PromotionContext'

export const useRewardValidations = (promotionCondition) => {
    const {promotion} = usePromotion()
    const sequenceNumber = promotionCondition?.sequence || 1
    const currentReward = promotionCondition?.rewards?.[0]
    const currentRewardValue = currentReward?.discountValue || currentReward?.points || currentReward?.quantity
    const currentBuyQuantity = promotionCondition?.conditionGroup?.conditions?.[0]?.quantity

    // get the highest sequence less than the current one (to account for a deleted middle layer)
    const prevCondition = promotion?.promotionConditions?.filter(cond => cond?.sequence < sequenceNumber).sort((a, b) => b.sequence - a.sequence)[0]

    const hasValueLayerError = () => {
        if (sequenceNumber === 1 || !currentRewardValue) return false
        const prevReward = prevCondition?.rewards?.[0]
        const prevRewardValue = prevReward?.discountValue || prevReward?.points || prevReward?.quantity
        return prevRewardValue >= currentRewardValue
    }

    const hasBuyQuantityLayerError = () => {
        if (sequenceNumber === 1 || !currentBuyQuantity) return false
        const prevQuantity = prevCondition?.conditionGroup?.conditions?.[0]?.quantity
        return prevQuantity >= currentBuyQuantity || (!prevQuantity && currentBuyQuantity)
    }

    return {
        hasValueLayerError,
        hasBuyQuantityLayerError,
    }
}